import { render, staticRenderFns } from "./user_new_rank.vue?vue&type=template&id=a912ab22&scoped=true&"
import script from "./user_new_rank.vue?vue&type=script&lang=js&"
export * from "./user_new_rank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a912ab22",
  null
  
)

export default component.exports